// Configuration for the Requests tab (order requests, 3 Nov 2026; Platform Admin only). The same discipline as
// api/adminVideos/config.ts: strict equality, and 'off' (the committed default, and UAT and prod today: no variable
// there compiles to undefined) means the tab and the request page do not exist at all.
//
// MOCK NEVER IN A PRODUCTION BUILD: NODE_ENV comes from the build command and no environment variable can change it,
// so a deployed build maps 'mock' to 'off' whatever a variable says (Igor's review of #82).
const MOCK_ALLOWED = process.env.NODE_ENV !== 'production';

export const ADMIN_REQUESTS_MODE: 'off' | 'mock' | 'live' =
  process.env.REACT_APP_ADMIN_REQUESTS_MODE === 'live'
    ? 'live'
    : process.env.REACT_APP_ADMIN_REQUESTS_MODE === 'mock' && MOCK_ALLOWED
      ? 'mock'
      : 'off';

// '/api/v1/admin/requests' on dev (dev-cicd.yaml, Joey 3 Nov). Live with no path is off: no tab that can only fail.
export const ADMIN_REQUESTS_PATH = process.env.REACT_APP_ADMIN_REQUESTS_PATH || '';

export const ADMIN_REQUESTS_ENABLED = ADMIN_REQUESTS_MODE === 'mock' || (ADMIN_REQUESTS_MODE === 'live' && ADMIN_REQUESTS_PATH !== '');

export const ADMIN_REQUESTS_TIMEOUT_MS = 30_000;

/** A page of the list, the gateway's most (it never says how many there are in all). */
export const ADMIN_REQUESTS_PAGE = 50;

// The words a person types, bounded as the gateway bounds them (contract 4.3); the gateway checks again.
export const ADMIN_REQUEST_LIMITS = {
  searchMax: 100,
  videoSearchMax: 200,
  reasonMin: 10,
  reasonMax: 500,
  noteMax: 500,
} as const;

/** An approval runs from tomorrow to this many days ahead at most; 14 by default (config/order_requests, defaults). */
export const APPROVAL_DEFAULT_DAYS = 14;
export const APPROVAL_MAX_DAYS = 90;

export const ADMIN_REQUEST_STATUSES = ['waiting', 'approved', 'declined', 'expired', 'purchased'] as const;
// Quotes are paused: no "quote" type filter (Joey, 3 Nov).
export const ADMIN_REQUEST_KINDS = ['courtesy_of', 'getty_images'] as const;
export const VIDEO_APPROVAL_FILTERS = ['needs', 'unknown', 'always', 'never', 'all'] as const;
export const VIDEO_SETTINGS = ['automatic', 'always', 'never'] as const;

/** A request id and a video id, as the gateway makes them. Anything else is never sent. */
export const ADMIN_REQUEST_ID_PATTERN = /^[A-Za-z0-9]{20}$/;
export const ADMIN_VIDEO_ID_PATTERN = /^[0-9a-f]{32}$/;
